"use strict";
import React from "react";
import PropTypes from "prop-types";
import FormsyFields from "./formsyFields";

const initComponent = (flex = window.flex) => {

    class CodePicker extends React.Component {

        static propTypes = {
            name: PropTypes.string.isRequired,
            codes: PropTypes.array.isRequired
        }

        static defaultProps = {
            label: '',
            single: false,
            help: null,
            showFullOptions: false,
            disabledToggle: false,
            onChange: () => { }
        }

        state = {
            invalidCodes: []
        }

        componentDidMount() {
            const availableCodes = (!this.props.codes || !this.props.codes.length) ? [] :
                typeof this.props.codes[0] === "object" ? _.map(this.props.codes, (code) => code.code ) :
                    this.props.codes;

            const selectedCodes = typeof this.props.value === "object" && this.props.value || [];

            const invalidCodes = selectedCodes.filter(x => availableCodes.indexOf(x) === -1).map(code => {
                return { code: code, summary: "Invalid Selection", isInvalid: true }
            });

            this.setState({
                invalidCodes: invalidCodes
            });
        }

        toggleCode(code) {
            const sequenceInput = this.refs["codeSequence-" + code.code];
            let sequence = -1;
            if (sequenceInput) {
                sequence = sequenceInput.value;
                if (sequence === -1) {
                    sequence = value.length - 1;
                }
            }

            let value = this.props.single ? code.code : this.props.value || [];

            if (!this.props.single) {
                const picked = (value.indexOf(code.code) !== -1);
                if (picked) {
                    _.pull(value, code.code);
                } else {
                    if (sequence === -1) {
                        value.push(code.code);
                    } else {
                        value.splice(sequence - 1, 0, code.code);
                    }
                }
            }
            if (this.props.single && !this.props.required && this.props.value === code.code) {
                value = "";
            }
            this.props.onSetValue(value);
            this.props.onChange(this.props.name, value, sequence);
        }

        updateSequence(code) {
            const value = this.props.single ? code.code : this.props.value || [];
            const sequence = this.refs["codeSequence-" + code.code].value;
            if (!this.props.single) {
                const picked = (value.indexOf(code.code) !== -1);
                if (picked) {
                    _.pull(value, code.code);
                }
                value.splice(sequence - 1, 0, code.code);
            }
            this.props.onSetValue(value);
            this.props.onChange(this.props.name, value, sequence);
        }

        renderElement() {
            const showFullCodes = this.props.showFullCodes || false;
            const enableSequence = this.props.enableSequence || false;
            if (!this.props || !this.props.codes) {
                return false;
            }

            const availableCodes = (!this.props.codes || !this.props.codes.length) ? [] :
                typeof this.props.codes[0] === "string" ? _.map(this.props.codes, (code) => { return { code: code, summary: code } }) :
                    this.props.codes;

            const selectedCodes = this.props.value || [];

            var sortedCodes = availableCodes;
            var divStyle = {};
            if (enableSequence) {
                sortedCodes = _.sortBy(availableCodes, (x) => {
                    var index = _.indexOf(this.props.value, x.code);
                    return index === -1 ? 999 : index;
                });
            } else {
                divStyle = { float: 'left' };
            }

            sortedCodes = sortedCodes.concat(this.state.invalidCodes);

            const controls = sortedCodes.map((code, key) => {

                const picked = this.props.single ? this.props.value === code.code : selectedCodes.indexOf(code.code) !== -1;
                const controlDisabled = this.props.disabled;
                const disabledToggle = this.props.disabledToggle;
                if (controlDisabled && !picked && !this.props.showFullOptions) {
                    return false;
                }
                const disabled = controlDisabled || code.disabled;
                let className = "codepicker-option";
                if (picked) {
                    if (!code.isInvalid){
                        className += " picked";
                    } else {
                        className += " invalid";
                    }
                }
                if (disabled) {
                    className += " disabled";
                }
                let sequenceInput = false;
                if (enableSequence) {
                    sequenceInput = <input type="text" ref={"codeSequence-" + code.code} onChange={this.updateSequence.bind(this, code)} defaultValue={key + 1} style={{ width: "2.25em", margin: ".2em" }} />;
                }


                return (
                    <div key={code.code + key} style={divStyle}>
                        {sequenceInput}
                        <a className={className} onClick={disabled || (disabledToggle && picked) ? null : this.toggleCode.bind(this, code)} title={code.summary}>
                            <input type="hidden" ref={"code-" + key} value={picked ? code.code : false} />
                            <span className="label label-code">{(showFullCodes ? code.code : flex.simpleCode(code.code))}</span>
                        </a>
                    </div>
                );
            });
            return controls;
        }

        render() {
            //unused, didn't find any files with this prop
            if (this.props.layout === 'elementOnly') {
                return (
                    <div className="codepicker">{this.renderElement()}</div>
                );
            }

            return (
                <FormsyFields.Row
                    label={this.props.label}
                    rowClassName={this.props.rowClassName}
                    labelClassName={this.props.labelClassName}
                    elementWrapperClassName={this.props.elementWrapperClassName}
                    layout={this.props.layout}
                    required={this.props.required}
                    showErrors={this.props.showErrors}
                    fakeLabel={true}
                >
                    <div className="codepicker">
                        {this.renderElement()}
                        {this.props.help && <FormsyFields.Help help={this.props.help} />}
                        {this.props.showErrors && <FormsyFields.ErrorMessages messages={this.props.errorMessages || []} />}
                        <div style={{ clear: "both" }}></div>
                    </div>
                </FormsyFields.Row>
            );
        }
    }

    return FormsyFields.FormsyReactComponent(CodePicker);
};

module.exports = initComponent;